import type { TLngLat } from 'App/Map/types'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'

export const getPropertyForSelectedStation = (selectedStation?: TLngLat | null) => {
  if (!selectedStation) {
    return null
  }

  return (
    Object.values(fieldAssetStore.getState().properties ?? {}).find((propertyData) => {
      return selectedStation && !!propertyData?.points?.[selectedStation]
    }) ?? null
  )
}
